import React from 'react'

import { ResizeContext } from 'contexts/Resize'

import WAboutCompareFirstMobile from './components/WAboutCompareFirstMobile'
import WAboutCompareFirstTablet from './components/WAboutCompareFirstTablet'

const WAboutCompareFirst = props => {
  const { mobile, tablet, breakpoint } = React.useContext(ResizeContext)

  if (mobile || breakpoint === '') {
    return <WAboutCompareFirstMobile {...props} />
  }

  return <WAboutCompareFirstTablet isTablet={tablet} {...props} />
}

export default WAboutCompareFirst
